module.exports = __webpack_public_path__ + "img/crownlogo.b7196d9c.png";